import React from 'react';
import { cn } from '~/lib/utils';

interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

export function Display({ className, children, ...props }: TypographyProps) {
  return (
    <h1
      className={cn(
        'font-fantasy text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </h1>
  );
}

export function H1({ className, children, ...props }: TypographyProps) {
  return (
    <h1
      className={cn(
        'font-fantasy text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </h1>
  );
}

export function H2({ className, children, ...props }: TypographyProps) {
  return (
    <h2
      className={cn(
        'font-fantasy text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </h2>
  );
}

export function H3({ className, children, ...props }: TypographyProps) {
  return (
    <h3
      className={cn(
        'font-fantasy text-xl md:text-2xl font-semibold tracking-tight text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </h3>
  );
}

export function H4({ className, children, ...props }: TypographyProps) {
  return (
    <h4
      className={cn(
        'font-body text-lg md:text-xl font-semibold text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </h4>
  );
}

export function BodyLarge({ className, children, ...props }: TypographyProps) {
  return (
    <p
      className={cn(
        'font-body text-lg leading-relaxed text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}

export function Body({ className, children, ...props }: TypographyProps) {
  return (
    <p
      className={cn(
        'font-body text-base leading-7 text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}

export function Small({ className, children, ...props }: TypographyProps) {
  return (
    <p
      className={cn(
        'font-body text-sm leading-relaxed text-muted-foreground',
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}

export function Caption({ className, children, ...props }: TypographyProps) {
  return (
    <p
      className={cn(
        'font-body text-xs font-medium uppercase tracking-wide text-muted-foreground',
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}

export function Lead({ className, children, ...props }: TypographyProps) {
  return (
    <p
      className={cn(
        'font-body text-xl leading-relaxed text-muted-foreground',
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}
